export enum ApFeatureModulKey {
  Administration = 'administration',
  BaseData = 'basedata',
  Fields = 'fieldmanagement',
  BaseFertilization = 'nutrients',
  Seedmaps = 'seedmaps',
  PlantProtection = 'plantprotection',
  NFertilization = 'nfertilization',
  Evaluation = 'evaluation',
  Import = 'import',
  Settings = 'settings',
  Satellite = 'satellite',
  Documentation = 'documentation',
  Fungidetect = 'fungidetect',
  EditHelp = 'edithelp',
  Academy = 'academy'
}
